import React, { useState, useCallback } from "react";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable"; // En vez de importar 'jspdf-autotable' globalmente
// Función para procesar archivos Excel
const parseExcelFile = (file, setColumns, setRows) => {
  const reader = new FileReader();
  
  reader.onload = (e) => {
    try {
      // Convertir datos del archivo a ArrayBuffer
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
       // Convertir hoja a JSON
      const jsonData = XLSX.utils.sheet_to_json(sheet, { 
        header: 1, 
        defval: "",
        blankrows: false
      });

      if (jsonData.length < 2) {
        throw new Error("El archivo debe contener al menos un encabezado y una fila de datos");
      }
      // Procesar encabezados y datos
      const headers = ["Selección", ...jsonData[0]];
      const rowData = jsonData.slice(1)
        .filter(row => row.length >= 2)
        .map((row, index) => [...row, `row-${Date.now()}-${index}`]); // ID único
      // Actualizar estados
      setColumns(headers);
      setRows(rowData);

    } catch (error) {
      console.error("Error al procesar el archivo:", error);
      alert(error.message || "Error al leer el archivo Excel");
    }
  };

  reader.onerror = () => alert("Error de lectura del archivo");
  reader.readAsArrayBuffer(file);
};
// Componente principal de carga de Excel
const ExcelUploader = () => {
  const [rows, setRows] = useState([]);//datos de filas
  const [columns, setColumns] = useState([]);//encabezados de columnas
  const [search, setSearch] = useState("");//termino de busqueda
  const [currentPage, setCurrentPage] = useState(1);//paginacion
  const [selectedRows, setSelectedRows] = useState(new Set());//filas seleccionadas
  const [isLoading, setIsLoading] = useState(false);//estado de carga
  
  const rowsPerPage = 10;// cantidad de filas en la tabla
//--------------------------------------------------------------
  // Mover filteredRows antes de su uso
  const filteredRows = rows.filter((row) => {
    const rowId = row[row.length - 1];
    if (selectedRows.has(rowId)) return false;
    return row.slice(0, -1).some(cell => 
      cell?.toString().toLowerCase().includes(search)
    );
  });
//--------------------------------------------------------------
//Manejador de carga de archivos
  const handleFileUpload = useCallback((event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.name.match(/\.(xlsx|xls|csv)$/i)) {
      alert("Formato de archivo no válido. Use .xlsx, .xls o .csv");
      return;
    }

    setIsLoading(true);
    setSelectedRows(new Set());
    
    parseExcelFile(file, setColumns, (parsedRows) => {
      setRows(parsedRows);
      setIsLoading(false);
    });
  }, []);
//manejador de busqueda
  const handleSearch = useCallback((event) => {
    setSearch(event.target.value.toLowerCase());
    setCurrentPage(1);
  }, []);
//alternar seleccion de fila individual
  const toggleRowSelection = useCallback((rowId) => {
    setSelectedRows(prev => {
      const newSet = new Set(prev);
      newSet.has(rowId) ? newSet.delete(rowId) : newSet.add(rowId);
      return newSet;
    });
  }, []);
//alternar seleccion de todas las filas visibles
  const toggleAllVisibleRows = useCallback(() => {
    const visibleIds = filteredRows.map(row => row[row.length - 1]);
    const allSelected = visibleIds.every(id => selectedRows.has(id));
    
    setSelectedRows(prev => {
      const newSet = new Set(prev);
      visibleIds.forEach(id => allSelected ? newSet.delete(id) : newSet.add(id));
      return newSet;
    });
  }, [filteredRows, selectedRows]);
//combinar filas seleccionadas y filtradas
  const displayedRows = [
    ...rows.filter(row => selectedRows.has(row[row.length - 1])),
    ...filteredRows
  ];
 // Lógica de paginación
  const totalPages = Math.ceil(displayedRows.length / rowsPerPage);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = displayedRows.slice(indexOfFirstRow, indexOfLastRow);
  const emptyRows = rowsPerPage - currentRows.length;
  const allVisibleSelected = filteredRows.length > 0 && 
    filteredRows.every(row => selectedRows.has(row[row.length - 1]));
 // Exportar a PDF con formato de tabla
  const exportToPDF = useCallback(() => {
    if (selectedRows.size === 0) return;
    const doc = new jsPDF();
    const selectedData = Array.from(selectedRows)
      .map(id => rows.find(row => row[row.length - 1] === id))
      .filter(Boolean)
      .map(row => row.slice(0, -1));

    if (selectedData.length === 0) return;

    // Encabezado
    doc.setFontSize(14);
    //doc.text("Reporte de Productos Seleccionados", 14, 22);
    doc.setFontSize(12);
    doc.setTextColor(100);
    doc.text(`Fecha: ${new Date().toLocaleDateString()}`, 14, 28);

    // Tabla
   // Configurar autoTable
   autoTable(doc, { // Usar autoTable importado directamente
    head: [columns.slice(1)],
    body: Array.from(selectedRows)
      .map(id => rows.find(row => row[row.length - 1] === id))
      .filter(Boolean)
      .map(row => row.slice(1, -1)),
    startY: 20,
    theme: 'grid',
    styles: { 
      fontSize: 10,
      cellPadding: 3,
      valign: 'middle'
    },
    headerStyles: {
      fillColor: [41, 128, 185],
      textColor: 255,
      fontStyle: 'bold'
    }
  });

  doc.save("reporte.pdf");
}, [selectedRows, rows, columns]);

  const clearSelection = useCallback(() => {
    setSelectedRows(new Set());
    setCurrentPage(1);
  }, []);

  return (
    <div className="container">
     { /*<h1 className="title">Cargador de Excel</h1>*/}
      
      <div className="upload-section">
        <input
          type="file"
          id="fileInput"
          accept=".xlsx,.xls,.csv"
          onChange={handleFileUpload}
          className="hidden-input"
        />
        <label htmlFor="fileInput" className="upload-button">
          {isLoading ? (
            <span className="loading-text">Cargando...</span>
          ) : (
            'Seleccionar Archivo Excel'
          )}
        </label>
      </div>

      {rows.length > 0 && (
        <div className="controls-section">
          <input
            type="text"
            placeholder="Buscar por código, producto o descripción..."
            value={search}
            onChange={handleSearch}
            className="search-input"
            aria-label="Campo de búsqueda"
          />
          
          <div className="buttons-group">
            <button
              onClick={exportToPDF}
              disabled={selectedRows.size === 0}
              className="action-button export"
              aria-label="Exportar a PDF"
            >
              📄 Exportar PDF
            </button>
            <button
              onClick={clearSelection}
              disabled={selectedRows.size === 0}
              className="action-button clear"
              aria-label="Limpiar selección"
            >
              ✖ Limpiar
            </button>
          </div>
        </div>
      )}

      {rows.length > 0 && (
        <div className="table-container">
          <table className="data-table" aria-label="Tabla de datos">
            <thead>
              <tr>
                <th className="checkbox-header">
                  <input
                    type="checkbox"
                    checked={allVisibleSelected}
                    onChange={toggleAllVisibleRows}
                    aria-label="Seleccionar todas las filas visibles"
                  />
                </th>
                {columns.slice(1).map((header, index) => (
                  <th key={index} className="column-header">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentRows.map((row) => {
                const rowId = row[row.length - 1];
                const isSelected = selectedRows.has(rowId);
                
                return (
                  <tr 
                    key={rowId}
                    className={`data-row ${isSelected ? 'selected' : ''}`}
                    onClick={() => toggleRowSelection(rowId)}
                    role="checkbox"
                    aria-checked={isSelected}
                    tabIndex={0}
                    onKeyDown={(e) => e.key === 'Enter' && toggleRowSelection(rowId)}
                  >
                    <td className="checkbox-cell">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => toggleRowSelection(rowId)}
                        aria-label={`Seleccionar fila ${row[0]}`}
                      />
                    </td>
                    {row.slice(0, -1).map((cell, cellIndex) => (
                      <td 
                        key={cellIndex} 
                        className="data-cell"
                        title={cell?.toString()}
                      >
                        {cell || <span className="empty-cell">-</span>}
                      </td>
                    ))}
                  </tr>
                );
              })}
              {emptyRows > 0 && Array.from({ length: emptyRows }).map((_, index) => (
                <tr key={`empty-${index}`} aria-hidden="true">
                  <td colSpan={columns.length}>&nbsp;</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="pagination-controls">
            <button
              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1}
              className="pagination-button"
            >
              « Primero
            </button>
            <button
              onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
              className="pagination-button"
            >
              ‹ Anterior
            </button>
            
            <span className="page-info">
              Página {currentPage} de {totalPages}
            </span>
            
            <button
              onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="pagination-button"
            >
              Siguiente ›
            </button>
            <button
              onClick={() => setCurrentPage(totalPages)}
              disabled={currentPage === totalPages}
              className="pagination-button"
            >
              Último »
            </button>
          </div>
        </div>
      )}

      <style jsx>{`
        .container {
          max-width: 1200px;
          margin: 0.2rem auto;
          padding: 0.2rem;
          font-family: 'Segoe UI', sans-serif;
        }

        .title {
          text-align: center;
          color: #2c3e50;
          margin-bottom: 2rem;
        }

        .hidden-input {
          display: none;
        }

        .upload-button {
          display: block;
          width: 300px;
          margin: 1rem auto;
          padding: 1rem 2rem;
          background: #3498db;
          color: white;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s ease;
          text-align: center;
          font-size: 1.1rem;
        }

        .upload-button:hover {
          background: #2980b9;
          transform: translateY(-2px);
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        }

        .loading-text {
          display: inline-block;
          animation: pulse 1.5s infinite;
        }

        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.5; }
          100% { opacity: 1; }
        }

        .controls-section {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          margin: 0.5rem 0;
          align-items: center;
          justify-content: center;
        }

        .search-input {
          flex: 1;
          max-width: 500px;
          padding: 0.8rem;
          border: 2px solid #bdc3c7;
          border-radius: 6px;
          font-size: 1rem;
          transition: border-color 0.3s ease;
        }

        .search-input:focus {
          outline: none;
          border-color: #3498db;
        }

        .buttons-group {
          display: flex;
          gap: 1rem;
        }

        .action-button {
          padding: 0.8rem 1.5rem;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .action-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .action-button.export {
          background: #27ae60;
          color: white;
        }

        .action-button.export:hover:not(:disabled) {
          background: #219a52;
        }

        .action-button.clear {
          background: #e74c3c;
          color: white;
        }

        .action-button.clear:hover:not(:disabled) {
          background: #c0392b;
        }

        .table-container {
          border: 1px solid #ecf0f1;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        }

        .data-table {
          width: 100%;
          border-collapse: collapse;
          background: white;
        }

        .checkbox-header, .checkbox-cell {
          width: 40px;
          text-align: center;
        }

        .column-header {
          padding: 0.5rem;
          background: #34495e;
          color: white;
          font-weight: 600;
          text-align: left;
        }

        .data-row {
          border-bottom: 1px solid #ecf0f1;
          transition: background 0.2s ease;
        }

        .data-row:hover {
          background: #f8f9fa;
        }

        .data-row.selected {
          background: #e3f2fd;
        }

        .data-cell {
          padding: 0.5rem;
          max-width: 300px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .empty-cell {
          color: #95a5a6;
          font-style: italic;
        }

        .pagination-controls {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 1rem;
          background: #f8f9fa;
          border-top: 1px solid #ecf0f1;
          gap: 0.5rem;
        }

        .pagination-button {
          padding: 0.6rem 1rem;
          border: 1px solid #bdc3c7;
          border-radius: 4px;
          background: white;
          color: #2c3e50;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .pagination-button:hover:not(:disabled) {
          background: #3498db;
          color: white;
          border-color: #3498db;
        }

        .pagination-button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .page-info {
          margin: 0 1rem;
          color: #7f8c8d;
          font-weight: 500;
        }
      `}</style>
    </div>
  );
};

export default ExcelUploader;